import React, { useEffect, useState } from 'react'; // Fixed syntax error here
import './webstoreServiceModal.scss';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify'; // Ensure toast is imported for notifications

// Add a new prop: onAddToCart (function to add item to cart)
const WebstoreServiceModal = ({ service, user, onClose, onAddToCart }) => {
  const [mainImage, setMainImage] = useState('');

  useEffect(() => {
    if (service?.images?.length > 0) {
      setMainImage(service.images[0]);
    }
  }, [service]);

  if (!service) return null;

  // Function to handle adding the service to the cart
  const handleAddToCartClick = () => {
    if (user) {
      // Call the onAddToCart prop function passed from the parent (Webstore.jsx)
      if (typeof onAddToCart === 'function') {
        onAddToCart(service);
        toast.success(`${service.title} added to cart!`);
        onClose(); // Close the modal after adding to cart
      } else {
        console.error("onAddToCart prop is not a function.");
        toast.error("Could not add to cart due to an internal error.");
      }
    } else {
      toast.error("Please log in to add items to your cart.");
      // Optionally, you could navigate to login page here, but usually,
      // a toast message is enough for a modal action.
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>
          <CloseIcon />
        </button>

        <div className="modal-body">
          {/* LEFT: IMAGES */}
          <div className="image-section">
            <div className="main-image">
              {mainImage ? (
                <img src={mainImage} alt={`${service.title} preview`} />
              ) : (
                <div className="image-placeholder">No Image Available</div>
              )}
            </div>

            {service.images?.length > 1 && (
              <div className="thumbnail-row">
                {service.images.map((img, index) => (
                  <img
                    key={index}
                    src={img}
                    alt={`Thumbnail ${index + 1}`}
                    className={`thumbnail ${mainImage === img ? 'active' : ''}`}
                    onClick={() => setMainImage(img)}
                  />
                ))}
              </div>
            )}
          </div>

          {/* RIGHT: DETAILS */}
          <div className="details-section">
            <h2>{service.title}</h2>
            <p className="category">{service.category}</p>
            <p className="price">₱{service.price.toFixed(2)}</p>

            <p className="delivery">
              Delivery within {service.deliveryTime || 3}{' '}
              {(service.deliveryTime || 3) === 1 ? 'day' : 'days'}
            </p>

            <p className="description">{service.description}</p>

            {/* Add to Cart Button */}
            <div className="modal-actions">
              {user ? (
                <button className="add-to-cart-btn" onClick={handleAddToCartClick}>
                  Add to Cart
                </button>
              ) : (
                // <button className="login-to-add-btn" onClick={() => toast.error("Please log in to add items to your cart.")}>
                //   Login to Add
                // </button>
                <button className="login-to-add-btn">
                 
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebstoreServiceModal;
